import { useState } from 'react'
import type { ReactNode } from 'react'
import { ExpertCtx, useExpert } from '@/hooks/useExpert'
import { cn } from '@/lib/utils'

// 전문가 토글. 기본 화면은 행정가의 것만 보이고, 켜면 **같은 자리에** 상세 필드가 드러난다.
// 별도 메뉴·카드·열로 가르지 않는다 — 주 값 아래의 보조 줄(ExpertLine)과 Facts 의 추가 행뿐이다.
// 토글의 상태는 상단 바에 늘 보이고, 새로고침하면 꺼진다(세션과 같다).
//
// 켜도 나오지 않는 것: 이벤트·상태 기계의 원값·비밀. 그것은 화면의 것이 아니다.

export function ExpertProvider({ children, initial = false }: { children: ReactNode; initial?: boolean }) {
  const [on, setOn] = useState(initial)
  return <ExpertCtx.Provider value={{ on, toggle: () => setOn((v) => !v) }}>{children}</ExpertCtx.Provider>
}

export type ExpertItem = ReactNode | null | undefined | false

/**
 * 주 값 아래의 보조 줄. 전문가가 켜져 있고 보일 항목이 하나라도 있을 때만 그린다.
 * 항목은 ` · ` 로 잇고, 비어 있는 항목은 건너뛴다.
 */
export function ExpertLine({ items, mono = false, className }: { items: ExpertItem[]; mono?: boolean; className?: string }) {
  const { on } = useExpert()
  if (!on) return null
  const shown = items.filter((item) => item !== null && item !== undefined && item !== false && item !== '')
  if (shown.length === 0) return null
  return (
    <div className={cn('mt-0.5 truncate text-[11px] text-muted-foreground', mono && 'font-mono', className)}>
      {shown.map((item, index) => (
        <span key={index}>
          {index > 0 ? ' · ' : ''}
          {item}
        </span>
      ))}
    </div>
  )
}
